export const COMMENTER_USERNAME_KEY = "commenter_username";
export const LIKED_BY_USERNAME_KEY = "username";

export const COMMENT_SOURCE = {
  USER_INPUT: 1, // undefined also means user input. undefined comes in case of branded community and 1 in case of RC
  RC_EXAM_SUBMISSION: 2, // in RC, exam submission appears as a comment, if creator wants
  RC_FORM_SUBMISSION: 3,
};
